import { withRouter } from 'react-router-dom';

import Megatable from '../../base/megatable/megatable';
import './publisher-megatable.scss';

class PublisherArticleMegatable extends Megatable {
  constructor(props) {
    /*
     * Since megatable constructor must be called first (cannot define
     * properties on 'this' before super is called), we must pass the statType
     * with super.
     */
    const statType = 'article';
    const tableName = 'Stories';
    const disableEditUrl = false;

    super(props, statType, tableName, disableEditUrl);
  }
}

class PublisherMerchantMegatable extends Megatable {
  constructor(props) {
    const statType = 'merchant';
    const tableName = 'Merchants';

    super(props, statType, tableName);
  }
}

class PublisherProductMegatable extends Megatable {
  constructor(props) {
    const statType = 'product';
    const tableName = 'Products Purchased';

    super(props, statType, tableName);
  }
}

class PublisherSmartlinkMegatable extends Megatable {
  constructor(props) {
    const statType = 'smartlink';
    const tableName = 'Links';
    const disableEditUrl = true;

    super(props, statType, tableName, disableEditUrl);
  }
}

const ArticleMegatable = withRouter(PublisherArticleMegatable);
const MerchantMegatable = withRouter(PublisherMerchantMegatable);
const ProductMegatable = withRouter(PublisherProductMegatable);
const SmartlinkMegatable = withRouter(PublisherSmartlinkMegatable);

export {
  PublisherArticleMegatable, // For unit test
  /* Components */
  ArticleMegatable,
  MerchantMegatable,
  ProductMegatable,
  SmartlinkMegatable,
};
